@let isMinified = minified();
@let icComplete = isUploadComplete();

<header class="header">
  <div class="title">
    {{ `upload.title${icComplete ? 'Done' : ''}` | translate }}
  </div>

  <div class="actions">
    @let icon = isMinified ? 'chevron-up' : 'chevron-down';
    @let action = isMinified ? 'expand' : 'minify';
    <evc-button
      size="small"
      [icon]="icon"
      frame="ghost"
      [label]="`upload.actions.${action}` | translate"
      (click)="toggle()">
    </evc-button>

    @if (icComplete) {
      <evc-button
        size="small"
        icon="close"
        frame="ghost"
        [disabled]="isUploading()"
        [label]="'upload.actions.dismissAll' | translate"
        (click)="close()">
      </evc-button>
    }
  </div>
</header>

<div
  class="content"
  [attr.aria-hidden]="isMinified">
  <div
    class="list"
    [ngClass]="{ 'list--minified': isMinified }">
    @for (current of files$ | async; track trackByName($index, current)) {
      <drive-upload-file
        class="file"
        [current]="current"
        (cancelUpload)="cancelFile(current)"></drive-upload-file>
    }
  </div>

  <footer class="footer">
    <evc-button
      class="footer__action"
      frame="none"
      type="destructive"
      [text]="'upload.close' | translate"
      (click)="close()" />
  </footer>
</div>

<!-- <pre class="_debug">
  done: {{ isUploadDone() }}
  uploading: {{ isUploading() }}
  hasError: {{ hasError() }}
  hasNoAlert: {{ hasNoAlert() }}
</pre> -->
